'use client';

import { c as _c } from "react/compiler-runtime";
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import useModalStore from '@module/stores/useModalStore';
import { MyMenuCouponUp } from '@module/svg/icons';
import { DropdownMenuItem } from '@pc/components/ui/dropdown-menu';
import type { ReactNode } from 'react';
function CouponRegistrationMenuItem(t0) {
  const $ = _c(7);
  const {
    children
  } = t0;
  const pushModal = useModalStore(_temp);
  const {
    isLogin
  } = useGetLoginInfoQuery();
  let t1;
  if ($[0] !== isLogin || $[1] !== pushModal) {
    t1 = () => {
      if (isLogin) {
        pushModal({
          type: "ADD_COUPON_MODAL",
          id: "CouponRegistrationMenuItem"
        });
      } else {
        pushModal({
          type: "AUTH_MODAL",
          id: "CouponRegistrationMenuItem"
        });
      }
    };
    $[0] = isLogin;
    $[1] = pushModal;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MyMenuCouponUp className="mr-5 h-5 w-5" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t1) {
    t3 = <div className="rounded-[10px] hover:bg-colorBg03"><DropdownMenuItem className="w-fit cursor-pointer px-[10px]" onClick={t1}>{t2}{children}</DropdownMenuItem></div>;
    $[4] = children;
    $[5] = t1;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
function _temp(state) {
  return state.pushModal;
}
export default CouponRegistrationMenuItem;